<template>
  <div class="paymentBox">
    <el-dialog
            title="用户充值协议"
            :visible.sync="agreement"
            width="50%"
    height="500px">
      <agreement-recharge></agreement-recharge>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreement = false">取 消</el-button>
        <el-button type="primary" @click="agreementBtn()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
            title="请使用微信扫码支付"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            center
            width="400px"
            :before-close="handleClose">
      <div class="dialogCode">
        <qriously :value="code_url" :size="250" />
      </div>
      <p class="paymentTips" v-if="!isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
      <p class="alreadyPaymentTips" v-if="isOrderPayment"><i class="paymentTips-icon el-icon-error"></i>{{paymentTips}}</p>
    </el-dialog>
    <div class="manage-title"><em class="txt">选择充值金额</em></div>
    <ul class="set-meal">
      <li v-for="(item,index) in list" :key="index" :class="{active:index===meal}" @click="getPrice(index,item.id)">
        <p class="select absolute"><i class="el-icon-check"></i></p>
        <p class="clicks">{{item.money}}元</p>
        <p class="price">赠送{{item.give_money}}元</p>
      </li>
    </ul>
    <el-checkbox v-model="checked">我已阅读并同意<a class="ff9203" @click="agreement = true">《用户充值协议》</a></el-checkbox>
    <div class="btn">
      <el-button type="primary" style="width:220px;" @click="ConfirmPayment">确认支付</el-button>
    </div>
  </div>
</template>
<script>
  import {
    epRecharge,
    payResult
  } from '@/config/api.js'
  import AgreementRecharge from '@/components/AgreementRecharge'
  export default {
    name: 'RechargePayment',
    inject:['reload'],
    components: {AgreementRecharge},
    props: {
      list: Array
    },
    data () {
      return {
        price_id: '',
        code_url: '',
        out_trade_no: '',
        dialogVisible: false,
        timer: null,
        paymentTips: '订单未支付',
        isOrderPayment: false,
        meal: '',
        agreement: false,
        checked: false,
      }
    },
    methods: {
      ConfirmPayment () {
        if (!this.price_id) {
          this.$message.error('请选择金额')
        } else {
          if (this.checked) {
            let data = {
            user_id: this.$store.state.user_id,
            user_type: this.$store.state.user_type,
            openid: this.$store.state.openid,
            price_id: this.price_id
          };
          this.$post(epRecharge,data)
                  .then(res => {
                    // window.console.log(res);
                    let data = res.data;
                    this.code_url = data.code_url;
                    this.out_trade_no = data.out_trade_no;
                    this.dialogVisible = true; //弹出支付二维码
                    this.timer = setInterval( () => {
                      this.paymentResult()
                    },2000)
                  })
                  .catch( () => {
                    this.$message.error('生成二维码失败，请重新再试');
                    this.hideLoading();
                    // window.console.log(err)
                  })
          } else {
            this.$message.error('你还没有阅读并同意用户充值协议')
          }
        }
      },
      //支付状态判断
      paymentResult () {
        let data = {
          pay_type: 1,
          out_trade_no: this.out_trade_no,
        };
        this.$post(payResult,data)
                .then(() => {
                  window.clearInterval(this.timer);
                  this.timer = null;
                  this.isOrderPayment = true;
                  this.paymentTips = '订单已支付成功';
                  setTimeout( () => {
                    this.reload()
                  },1000)
                })
                .catch( () => {
                  // this.$message.error(err.msg)
                })
      },
      agreementBtn () {
        this.agreement = false;
        this.checked = true;
      },
      handleClose () {
        this.dialogVisible = false;
        this.hideLoading();
        window.clearInterval(this.timer);
        this.timer = null
      },
      getPrice (index,id) {
        this.meal=index;
        this.price_id = id
      }
    },
    destroyed() {
      this.timer && window.clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>
<style scoped>
  .select-click{margin:20px 0;}
  .select-click .item{width:200px;height:auto;}
  .select-click .item p{width: 100%;text-align: center;}
  .select-click .item .number{font-size:36px;}
  .select-click .item .estimate{color: #999;margin-top:10px;}
  .select-click .item .price{font-size:16px;margin-top:10px;}
  .select-payment{margin-top:20px;}
  .btn{margin-top:20px;}
  .set-meal{margin-top:20px;}
  .set-meal li .clicks{font-size:24px;color:#000;margin-top:20px;}
</style>
